import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    input: {
        id: '_.rbl_sweep_select.input',
        defaultMessage:
            'Choose the percentage of your monthly revenue to repay with'
    }
});
